<div fxLayout="row" fxLayoutAlign="center center">
	<div fxFlex="90">
		<mat-card>
			<mat-card-title> Society Ticket System</mat-card-title>		 
			<p>Here society flat owners can add a Ticket if any complaint OR query...</p>
			<p><strong>Comming soon... This feature will be available on End of May 2021 OR first week of Jun 2021</strong></p>
			 
		</mat-card>
	</div>
</div>